import React, { Suspense } from "react";
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux'; // Creates the Central Redux Store
import { Provider } from 'react-redux';
import App from './app';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducer from './Reducers'; // Gets the root reducer to be used by the store
import { composeWithDevTools } from 'redux-devtools-extension';
import { PersistGate } from 'redux-persist/integration/react';
import { thunk } from 'redux-thunk';
import "./Styles/custom-bootstrap.scss";
import ErrorBoundary from './Components/Shared/ErrorBoundary';
import './i18n';
import i18n from './i18n';

const Loader = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: 'Lato, sans-serif'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '4px solid #e3e3e3',
      borderTop: '4px solid #007bff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '20px'
    }}></div>
    <h2 style={{ color: '#495057', margin: '0 0 10px 0' }}>Loading...</h2>
    <p style={{ color: '#6c757d', margin: '0' }}>Initializing Taplr application</p>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

// Migrations for the persisted state; bump `version` and add a step when a persisted key is renamed
const persistMigrations = {
  // Login.isTaplrAdmin was renamed to Login.isFlagstoneAdmin; keep the value so users don't have to log in again
  1: (state) => {
    if (!state || !state.Login) return state;
    const { isTaplrAdmin, ...login } = state.Login;
    return { ...state, Login: { ...login, isFlagstoneAdmin: login.isFlagstoneAdmin ?? isTaplrAdmin ?? false } };
  },
};

const persistConfig = {
    key: 'root',
    storage: storage,
    version: 1,
    migrate: createMigrate(persistMigrations, { debug: false }),
  };

const pReducer = persistReducer(persistConfig, reducer);

//hook up the redux devtools browser extension
export const store = createStore(pReducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);


const persistor = persistStore(store);

const syncLanguageToI18n = () => {
    const state = store.getState();
    const language = state.Language && state.Language.language;
    if (language) {
        i18n.changeLanguage(language);
    }
};

render(
    <ErrorBoundary>
        <Provider store={store}>
            <Suspense fallback={<Loader />}>
                <PersistGate persistor={persistor} onBeforeLift={syncLanguageToI18n}>
                    <App />
                </PersistGate>
            </Suspense>
        </Provider>
    </ErrorBoundary>,

    document.getElementById('root')
);

